import { useEffect, useState } from "react";
import { connect } from "react-redux";

// Formik and Yup
import { useFormik } from "formik";
import Select from "react-select";
import * as Yup from "yup";

// Utils component
import TextError from "utils/TextError";

// Dashboard example components
import DataTable from "examples/Tables/DataTable";

// Dashboard components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDCard from "components/MDCard";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";

import DownloadButton from "components/standardized-components/DownloadButton";
import DownloadDataButton from "components/standardized-components/DownloadDataButton";
import UploadButton from "components/standardized-components/UploadButton";
import { CSVLink } from "react-csv";
import { toast } from "react-toastify";

import { CustomToastContent } from "../../../examples/CustomToastContent/index";

// @mui material components
import { Backdrop } from "@mui/material";
import Alert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";
import Collapse from "@mui/material/Collapse";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import Tooltip from "@mui/material/Tooltip";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import CloseIcon from "@mui/icons-material/Close";
import Icon from "@mui/material/Icon";

// Custom standard components
import CreateButton from "components/standardized-components/CreateButton";
import DeleteButton from "components/standardized-components/DeleteButton";
import EditButton from "components/standardized-components/EditButton";

import {
  createCareAndUseInstructions,
  deleteCareAndUseInstructions,
  editCareAndUseInstructions,
  getAllCareAndUseInstructions,
  getProductsListForDpp,
  getSubModulesByRoleId,
  uploadCsvForCareAndUseInstructions,
} from "../../../store";

// Cookies
import Cookies from "universal-cookie";

const cookies = new Cookies();

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 350, lg: 800 },
  height: "fit-content",
  maxHeight: "90%",
  boxShadow: 24,
  p: 0,
  pt: 2,
  overflow: "auto",
  // overflowX: "hidden",
};

const styleForEdit = { ...style, p: 1, pt: 3 };

const deleteStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  boxShadow: 24,
  p: 2,
  pt: 3,
};

// ================= DROPDOWN OPTIONS =================
const yesNoOptions = [
  { label: "Yes", value: 1 },
  { label: "No", value: 0 },
];

const flammabilityOptions = [
  { label: "Flammable", value: 1 },
  { label: "Non Flammable", value: 0 },
];

const riskLevelOptions = [
  { label: "Low", value: "Low" },
  { label: "Medium", value: "Medium" },
  { label: "High", value: "High" },
];

const unNumberOptions = [{ label: "UN 3480", value: "UN 3480" }];
const transportClassOptions = [{ label: "Class 9", value: "Class 9" }];
const shippingNameOptions = [
  { label: "Lithium-ion batteries", value: "Lithium-ion batteries" },
];
const packingInstructionOptions = [{ label: "PI 965", value: "PI 965" }];
// =========================================================

const CareAndUseInstructions = ({
  getAllCareAndUseReducer,
  getProductsListForDppReducer,
  getAllCareAndUseInstructions,
  createCareAndUseInstructions,
  editCareAndUseInstructions,
  deleteCareAndUseInstructions,
  getProductsListForDpp,
  dppIdSelectedForGlobalFilter,
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
  uploadCsvForCareAndUseInstructions,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");
  let jwtToken = loginDetails?.jwt;
  let userId = loginDetails?.data?.userId || "system";
  let roleId = loginDetails.data.roleId;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let allocateAccess = true;
  let viewAccess = true;
  let editAccess = true;
  let deleteAccess = true;

  const [loading, setLoading] = useState(true);
  const [dppOptions, setDPPOptions] = useState([]);

  useEffect(() => {
    getProductsListForDpp(jwtToken);
  }, [jwtToken]);

  useEffect(() => {
    let tempDppOptions = [];
    let dataList = getProductsListForDppReducer?.productsListForDpp?.data
      ? getProductsListForDppReducer.productsListForDpp.data
      : [];

    dataList.forEach((item) => {
      tempDppOptions.push({
        label: item.dppCode,
        value: item.dppId,
      });
    });
    setDPPOptions(tempDppOptions);
  }, [getProductsListForDppReducer]);

  useEffect(() => {
    getAllCareAndUseInstructions(jwtToken);
  }, [dppIdSelectedForGlobalFilter, jwtToken]);

  // ================= VIEW MODAL LOGIC =================
  const [openViewModal, setOpenViewModal] = useState(false);
  const [singleDataForView, setSingleDataForView] = useState({});

  const handleOpenViewModal = (data) => {
    setSingleDataForView(data);
    setOpenViewModal(true);
  };

  const handleCloseViewModal = (event, reason) => {
    if (reason === "backdropClick") return;
    setOpenViewModal(false);
    setSingleDataForView({});
  };

  const getDisplayValue = (val, isYesNo = false, isFlammable = false) => {
    if (val === undefined || val === null) return "-";
    if (isYesNo) return val === 1 ? "Yes" : val === 0 ? "No" : val;
    if (isFlammable)
      return val === 1 ? "Flammable" : val === 0 ? "Non Flammable" : val;
    return val;
  };

  const [state, setState] = useState({
    columns: [
      { Header: "Care ID", accessor: "careId" },
      { Header: "DPP ID", accessor: "dppId" },
      { Header: "Wash Temp.", accessor: "washTemperature" },
      { Header: "Bleach", accessor: "bleachAllowedDisplay" },
      { Header: "Fire Risk Lvl", accessor: "fireRiskLevel" },
      {
        Header: "Action",
        accessor: "action",
        cannotSearch: true,
        cannotSort: true,
      },
    ],
    rows: [],
  });

  const { columns, rows } = state;

  const headers = [
    { label: "DPP Code", key: "dppCode" },
    { label: "Handling Instructions", key: "handlingInstructions" },
    { label: "Installation Instructions", key: "installationInstructions" },
    { label: "Storage Instructions", key: "storageInstructions" },
    { label: "Transportation Instructions", key: "transportationInstructions" },
    { label: "Disposal Instructions", key: "disposalInstructions" },
    { label: "Packing Instruction", key: "packingInstruction" },
  ];

  const headersForTemp = [
    { label: "dppCode", key: "dppCode" },
    { label: "handlingInstructions", key: "handlingInstructions" },
    { label: "installationInstructions", key: "installationInstructions" },
    { label: "storageInstructions", key: "storageInstructions" },
    { label: "transportationInstructions", key: "transportationInstructions" },
    { label: "disposalInstructions", key: "disposalInstructions" },
    { label: "packingInstruction", key: "packingInstruction" },
  ];

  const csvExportData = (
    getAllCareAndUseReducer?.careAndUseList?.data || []
  ).map((item) => ({
    dppCode: item.dppCode,
    handlingInstructions: item.handlingInstructions,
    installationInstructions: item.installationInstructions,
    storageInstructions: item.storageInstructions,
    transportationInstructions: item.transportationInstructions,
    disposalInstructions: item.disposalInstructions,
    packingInstruction: item.packingInstruction,
  }));

  const csvLink = {
    filename: "Care & Use Instructions List.csv",
    headers: headers,
    data: csvExportData,
  };

  const csvLink2 = {
    filename: "Care & Use Instructions Upload Template.csv",
    headers: headersForTemp,
    data: [],
  };

  const [showUploadPanel, setShowUploadPanel] = useState(false);
  const [uploadCsvData, setUploadCsvData] = useState(null);

  const handleUploadClick = () => {
    setShowUploadPanel(!showUploadPanel);
    setUploadCsvData(null);
  };

  const uploadCsvHandler = async () => {
    if (!uploadCsvData) {
      toast.error("Please select a CSV file first!");
      return;
    }

    let formData = new FormData();
    formData.append("file", uploadCsvData);

    try {
      let res = await uploadCsvForCareAndUseInstructions(formData, jwtToken);

      if (res?.status === true || res?.data?.status === true) {
        setShowUploadPanel(false);
        setUploadCsvData(null);
        getAllCareAndUseInstructions(jwtToken);
      }

      showUploadNotification(res);
    } catch (error) {
      showUploadNotification(error);
    }
  };


  const showUploadNotification = (res) => {
    const payload = res?.response?.data || res?.data?.data || res?.data || res || {};

    const isSuccess = payload.status === true;
    const msg = payload.msg;
    const description = payload.description;

    const counts = {
      success: payload.successCount,
      error: payload.errorCount,
      duplicate: payload.duplicateCount
    };

    const toastOptions = {
      position: "top-center",
      autoClose: 5000,
      closeOnClick: false,
      draggable: true,
    };

    if (isSuccess) {
      toast.success(
        <CustomToastContent msg={msg} description={description} counts={counts} isSuccess={true} />,
        toastOptions
      );
    } else {
      toast.error(
        <CustomToastContent msg={msg} description={description} counts={counts} isSuccess={false} />,
        toastOptions
      );
    }
  };

  useEffect(() => {
    let tempMappedActivity = [];
    let data = getAllCareAndUseReducer?.careAndUseList?.data
      ? getAllCareAndUseReducer.careAndUseList.data
      : [];

    setLoading(getAllCareAndUseReducer?.loading || false);

    [...data].reverse().map((item) => {
      const itemObject = {
        careId: item.careId,
        dppId: item.dppId,
        washTemperature: item.washTemperature,
        bleachAllowedDisplay: item.bleachAllowed ? "Yes" : "No",
        fireRiskLevel: item.fireRiskLevel || "-",

        action: (
          <>
            {/* View Button Added Here */}
            {viewAccess && (
              <Tooltip title="View Details">
                <MDButton
                  variant="gradient"
                  color="info"
                  iconOnly
                  size="small"
                  type="button"
                  onClick={() => handleOpenViewModal(item)}
                  style={{ marginRight: "5px" }}
                >
                  <Icon>visibility</Icon>
                </MDButton>
              </Tooltip>
            )}

            {editAccess && (
              <EditButton
                tooltip="Edit"
                variant="gradient"
                color="success"
                iconOnly
                type="button"
                onClick={() => handleOpenUpdateModal(item)}
                style={{ marginRight: "5px" }}
              >
                <Icon>edit_sharp</Icon>
              </EditButton>
            )}

            {deleteAccess && (
              <DeleteButton
                tooltip="Delete"
                variant="gradient"
                color="error"
                iconOnly
                type="button"
                style={{ marginRight: "5px" }}
                onClick={() => handleOpenDeleteModal(item)}
              >
                <Icon>delete</Icon>
              </DeleteButton>
            )}
          </>
        ),
      };
      tempMappedActivity.push(itemObject);
    });

    setState((prevState) => ({ ...prevState, rows: tempMappedActivity }));
  }, [getAllCareAndUseReducer]);

  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [isSuccessCreate, setIsSuccessCreate] = useState(false);
  const [isErrorCreate, setIsErrorCreate] = useState(false);
  const [errorMsgCreate, setErrorMsgCreate] = useState("");
  const [createButtonName, setCreateButtonName] = useState("Create");

  const handleOpenCreateModal = () => {
    setOpenCreateModal(true);
    formik.setErrors({});
  };

  const handleCloseCreateModal = (event, reason) => {
    if (reason === "backdropClick") return;
    setOpenCreateModal(false);
    formik.resetForm();
  };

  useEffect(() => {
    if (isSuccessCreate) setTimeout(() => setIsSuccessCreate(false), 3000);
    if (isErrorCreate) setTimeout(() => setIsErrorCreate(false), 3000);
  }, [isSuccessCreate, isErrorCreate]);

  const initialValues = {
    DPPID: "",
    washTemperature: "",
    ironingInstructions: "",
    dryCleanStatus: "",
    tumbleDryInstructions: "",
    bleachAllowed: "",
    handlingInstructions: "",
    installationInstructions: "",
    chargingInstructions: "",
    storageInstructions: "",
    transportationInstructions: "",
    disposalInstructions: "",
    disassemblyInstruction: "",
    fireHazard: "",
    thermalRunawayRisk: "",
    flammability: "",
    fireRiskLevel: "",
    fireHazardDescription: "",
    chemicalHazard: "",
    chemicalRiskLevel: "",
    chemicalHazardDescription: "",
    electricalHazard: "",
    voltageHazardLevel: "",
    electricShockRisk: "",
    electricalRiskLevel: "",
    transportHazard: "",
    uNNumber: "",
    transportClass: "",
    properShippingName: "",
    packingInstruction: "",
  };

  const validationSchema = Yup.object({
    DPPID: Yup.object().required("Select DPP"),
    washTemperature: Yup.string().required(" "),
  });

  const onSubmit = async (values, { resetForm }) => {
    setCreateButtonName("Please wait...");
    const payload = {
      dppId: values.DPPID?.value,
      washTemperature: values.washTemperature,
      ironingInstructions: values.ironingInstructions,
      dryCleanStatus: values.dryCleanStatus,
      tumbleDryInstructions: values.tumbleDryInstructions,
      bleachAllowed: values.bleachAllowed?.value,
      handlingInstructions: values.handlingInstructions,
      installationInstructions: values.installationInstructions,
      chargingInstructions: values.chargingInstructions,
      storageInstructions: values.storageInstructions,
      transportationInstructions: values.transportationInstructions,
      disposalInstructions: values.disposalInstructions,
      disassemblyInstruction: values.disassemblyInstruction,
      fireHazard: values.fireHazard?.value,
      thermalRunawayRisk: values.thermalRunawayRisk?.value,
      flammability: values.flammability?.value,
      fireRiskLevel: values.fireRiskLevel?.value,
      fireHazardDescription: values.fireHazardDescription,
      chemicalHazard: values.chemicalHazard?.value,
      chemicalRiskLevel: values.chemicalRiskLevel?.value,
      chemicalHazardDescription: values.chemicalHazardDescription,
      electricalHazard: values.electricalHazard?.value,
      voltageHazardLevel: values.voltageHazardLevel?.value,
      electricShockRisk: values.electricShockRisk?.value,
      electricalRiskLevel: values.electricalRiskLevel?.value,
      transportHazard: values.transportHazard?.value,
      uNNumber: values.uNNumber?.value,
      transportClass: values.transportClass?.value,
      properShippingName: values.properShippingName?.value,
      packingInstruction: values.packingInstruction?.value,
      cdBy: userId,
    };

    let res = await createCareAndUseInstructions(payload, jwtToken);
    if (res.status) {
      setIsSuccessCreate(true);
      getAllCareAndUseInstructions(jwtToken);
      setTimeout(() => {
        setCreateButtonName("Create");
        handleCloseCreateModal();
      }, 2000);
    } else {
      setErrorMsgCreate(res?.data?.msg || "Something went wrong");
      setIsErrorCreate(true);
      setCreateButtonName("Create");
    }
  };

  const formik = useFormik({ initialValues, validationSchema, onSubmit });

  // ================= EDIT LOGIC =================
  const [openUpdateModal, setOpenUpdateModal] = useState(false);
  const [singleDataForUpdate, setSingleDataForUpdate] = useState({});
  const [isSuccessForUpdate, setIsSuccessForUpdate] = useState(false);
  const [isErrorForUpdate, setIsErrorForUpdate] = useState(false);
  const [errorMsgForUpdate, setErrorMsgForUpdate] = useState("");
  const [editButtonName, setEditButtonName] = useState("Update");

  const handleOpenUpdateModal = (data) => {
    setSingleDataForUpdate(data);
    setOpenUpdateModal(true);
  };
  const handleCloseUpdateModal = (event, reason) => {
    if (reason === "backdropClick") return;
    setOpenUpdateModal(false);
    formikForUpdate.resetForm();
  };

  useEffect(() => {
    if (isSuccessForUpdate)
      setTimeout(() => setIsSuccessForUpdate(false), 3000);
    if (isErrorForUpdate) setTimeout(() => setIsErrorForUpdate(false), 3000);
  }, [isSuccessForUpdate, isErrorForUpdate]);

  const getDropdownOption = (val, optionsArray) =>
    val !== undefined && val !== null
      ? optionsArray.find((o) => o.value === val) || ""
      : "";

  const initialValueForUpdate = {
    careId: singleDataForUpdate.careId || "",
    DPPID: singleDataForUpdate.dppId || "",
    washTemperature: singleDataForUpdate.washTemperature || "",
    ironingInstructions: singleDataForUpdate.ironingInstructions || "",
    dryCleanStatus: singleDataForUpdate.dryCleanStatus || "",
    tumbleDryInstructions: singleDataForUpdate.tumbleDryInstructions || "",
    bleachAllowed: getDropdownOption(
      singleDataForUpdate.bleachAllowed,
      yesNoOptions,
    ),
    handlingInstructions: singleDataForUpdate.handlingInstructions || "",
    installationInstructions:
      singleDataForUpdate.installationInstructions || "",
    chargingInstructions: singleDataForUpdate.chargingInstructions || "",
    storageInstructions: singleDataForUpdate.storageInstructions || "",
    transportationInstructions:
      singleDataForUpdate.transportationInstructions || "",
    disposalInstructions: singleDataForUpdate.disposalInstructions || "",
    disassemblyInstruction: singleDataForUpdate.disassemblyInstruction || "",
    fireHazard: getDropdownOption(singleDataForUpdate.fireHazard, yesNoOptions),
    thermalRunawayRisk: getDropdownOption(
      singleDataForUpdate.thermalRunawayRisk,
      yesNoOptions,
    ),
    flammability: getDropdownOption(
      singleDataForUpdate.flammability,
      flammabilityOptions,
    ),
    fireRiskLevel: getDropdownOption(
      singleDataForUpdate.fireRiskLevel,
      riskLevelOptions,
    ),
    fireHazardDescription: singleDataForUpdate.fireHazardDescription || "",
    chemicalHazard: getDropdownOption(
      singleDataForUpdate.chemicalHazard,
      yesNoOptions,
    ),
    chemicalRiskLevel: getDropdownOption(
      singleDataForUpdate.chemicalRiskLevel,
      riskLevelOptions,
    ),
    chemicalHazardDescription:
      singleDataForUpdate.chemicalHazardDescription || "",
    electricalHazard: getDropdownOption(
      singleDataForUpdate.electricalHazard,
      yesNoOptions,
    ),
    voltageHazardLevel: getDropdownOption(
      singleDataForUpdate.voltageHazardLevel,
      riskLevelOptions,
    ),
    electricShockRisk: getDropdownOption(
      singleDataForUpdate.electricShockRisk,
      yesNoOptions,
    ),
    electricalRiskLevel: getDropdownOption(
      singleDataForUpdate.electricalRiskLevel,
      riskLevelOptions,
    ),
    transportHazard: getDropdownOption(
      singleDataForUpdate.transportHazard,
      yesNoOptions,
    ),
    uNNumber: getDropdownOption(singleDataForUpdate.uNNumber, unNumberOptions),
    transportClass: getDropdownOption(
      singleDataForUpdate.transportClass,
      transportClassOptions,
    ),
    properShippingName: getDropdownOption(
      singleDataForUpdate.properShippingName,
      shippingNameOptions,
    ),
    packingInstruction: getDropdownOption(
      singleDataForUpdate.packingInstruction,
      packingInstructionOptions,
    ),
  };

  const validationSchemaEdit = Yup.object({ washTemperature: Yup.string() });

  const onSubmitForUpdate = async (values) => {
    setEditButtonName("Please wait...");
    const payload = {
      careId: values.careId,
      washTemperature: values.washTemperature,
      ironingInstructions: values.ironingInstructions,
      dryCleanStatus: values.dryCleanStatus,
      tumbleDryInstructions: values.tumbleDryInstructions,
      bleachAllowed: values.bleachAllowed?.value,
      handlingInstructions: values.handlingInstructions,
      installationInstructions: values.installationInstructions,
      chargingInstructions: values.chargingInstructions,
      storageInstructions: values.storageInstructions,
      transportationInstructions: values.transportationInstructions,
      disposalInstructions: values.disposalInstructions,
      disassemblyInstruction: values.disassemblyInstruction,
      fireHazard: values.fireHazard?.value,
      thermalRunawayRisk: values.thermalRunawayRisk?.value,
      flammability: values.flammability?.value,
      fireRiskLevel: values.fireRiskLevel?.value,
      fireHazardDescription: values.fireHazardDescription,
      chemicalHazard: values.chemicalHazard?.value,
      chemicalRiskLevel: values.chemicalRiskLevel?.value,
      chemicalHazardDescription: values.chemicalHazardDescription,
      electricalHazard: values.electricalHazard?.value,
      voltageHazardLevel: values.voltageHazardLevel?.value,
      electricShockRisk: values.electricShockRisk?.value,
      electricalRiskLevel: values.electricalRiskLevel?.value,
      transportHazard: values.transportHazard?.value,
      uNNumber: values.uNNumber?.value,
      transportClass: values.transportClass?.value,
      properShippingName: values.properShippingName?.value,
      packingInstruction: values.packingInstruction?.value,
      udBy: userId,
    };

    let res = await editCareAndUseInstructions(payload, jwtToken);
    if (res.status) {
      setIsSuccessForUpdate(true);
      getAllCareAndUseInstructions(jwtToken);
      setTimeout(() => {
        handleCloseUpdateModal();
        setEditButtonName("Update");
      }, 2000);
    } else {
      setIsErrorForUpdate(true);
      setErrorMsgForUpdate(res?.data?.msg || "Failed to update");
      setEditButtonName("Update");
    }
  };

  const formikForUpdate = useFormik({
    initialValues: initialValueForUpdate,
    validationSchema: validationSchemaEdit,
    onSubmit: onSubmitForUpdate,
    enableReinitialize: true,
  });

  // ================= DELETE LOGIC =================
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [singleDataForDelete, setSingleDataForDelete] = useState({});
  const [isSuccessForDelete, setIsSuccessForDelete] = useState(false);
  const [isErrorForDelete, setIsErrorForDelete] = useState(false);
  const [errorMsgForDelete, setErrorMsgForDelete] = useState("");
  const [deleteButtonName, setDeleteButtonName] = useState("Delete");

  const handleOpenDeleteModal = (data) => {
    setSingleDataForDelete(data);
    setOpenDeleteModal(true);
  };
  const handleCloseDeleteModal = () => {
    setOpenDeleteModal(false);
  };

  useEffect(() => {
    if (isSuccessForDelete)
      setTimeout(() => setIsSuccessForDelete(false), 2000);
    if (isErrorForDelete) setTimeout(() => setIsErrorForDelete(false), 3000);
  }, [isSuccessForDelete, isErrorForDelete]);

  const deleteRecord = async () => {
    setDeleteButtonName("Please wait...");
    let res = await deleteCareAndUseInstructions(
      singleDataForDelete.careId,
      userId,
      jwtToken,
    );
    if (res.status) {
      setIsSuccessForDelete(true);
      getAllCareAndUseInstructions(jwtToken);
      setTimeout(() => {
        handleCloseDeleteModal();
        setDeleteButtonName("Delete");
      }, 2000);
    } else {
      setIsErrorForDelete(true);
      setErrorMsgForDelete(res?.data?.msg || "Failed to delete");
      setDeleteButtonName("Delete");
    }
  };

  // UI Helpers
  const renderInput = (label, name, formikContext) => (
    <Grid item xs={12} lg={4}>
      <MDBox mb={2} ml={1}>
        <MDTypography variant="h6">{label}</MDTypography>
        <MDInput
          size="small"
          type="text"
          name={name}
          fullWidth
          autoComplete="off"
          value={formikContext.values[name]}
          onChange={formikContext.handleChange}
          onBlur={formikContext.handleBlur}
          error={
            formikContext.touched[name] && Boolean(formikContext.errors[name])
          }
        />
        {formikContext.touched[name] && formikContext.errors[name] && (
          <TextError msg={formikContext.errors[name]} />
        )}
      </MDBox>
    </Grid>
  );

  const renderSelect = (label, name, options, formikContext) => (
    <Grid item xs={12} lg={4}>
      <MDBox mb={2} ml={1}>
        <MDTypography variant="h6">{label}</MDTypography>
        <Select
          className="select-css"
          placeholder="Choose one..."
          name={name}
          value={formikContext.values[name]}
          options={options}
          onBlur={() => formikContext.handleBlur({ target: { name } })}
          onChange={(selectedOption) =>
            formikContext.setFieldValue(name, selectedOption)
          }
          menuPortalTarget={document.body}
          styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
        />
        {formikContext.touched[name] && formikContext.errors[name] && (
          <TextError msg={formikContext.errors[name]} />
        )}
      </MDBox>
    </Grid>
  );

  const renderViewField = (label, value) => (
    <Grid item xs={12} sm={6} lg={4}>
      <MDBox mb={2} ml={1}>
        <MDTypography
          variant="caption"
          fontWeight="bold"
          color="text"
          textTransform="uppercase"
        >
          {label}
        </MDTypography>
        <br />
        <MDTypography variant="button" fontWeight="medium" color="dark">
          {value || "-"}
        </MDTypography>
      </MDBox>
    </Grid>
  );

  return (
    <div>
      <MDBox pt={0} pb={0} mb={-2.5}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            {/* Header Actions */}
            {/* Header Actions */}
            <MDBox
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              p={0}
              mb={-4.5}
              mt={-1}
            >
              <MDBox
                color="text"
                px={2}
                ml={-2}
                mb={4}
                display="flex"
                alignItems="center"
              >
                {allocateAccess && (
                  <MDBox display="flex" alignItems="center">
                    <Tooltip>
                      <CreateButton
                        tooltip="Add Care & Use Instructions"
                        color="info"
                        variant="contained"
                        type="button"
                        iconOnly
                        onClick={handleOpenCreateModal}
                        style={{ borderRadius: "5px" }}
                        size="small"
                      >
                        <Icon>add</Icon>
                      </CreateButton>
                    </Tooltip>

                    <CSVLink {...csvLink}>
                      <DownloadDataButton
                        tooltip="Download Care & Use Instructions List"
                        style={{ marginLeft: "1rem" }}
                        type="button"
                        variant="outlined"
                        color="error"
                        iconOnly
                      >
                        <Icon>download</Icon>
                      </DownloadDataButton>
                    </CSVLink>

                    <UploadButton
                      tooltip="Upload CSV"
                      style={{ marginLeft: "1rem", marginTop: "2px" }}
                      type="button"
                      variant={showUploadPanel ? "contained" : "outlined"}
                      color="info"
                      iconOnly
                      onClick={handleUploadClick}
                    >
                      <Icon>upload</Icon>
                    </UploadButton>

                    <CSVLink {...csvLink2}>
                      <DownloadButton
                        tooltip="Download Template"
                        style={{ marginLeft: "1rem" }}
                        type="button"
                        variant="outlined"
                        color="error"
                        iconOnly
                      >
                        <Icon>description</Icon>
                      </DownloadButton>
                    </CSVLink>

                    {showUploadPanel && (
                      <MDBox
                        display="flex"
                        alignItems="center"
                        ml={2}
                        p={0.5}
                        px={2}
                      >
                        <input
                          className="choose_file"
                          type="file"
                          accept=".csv"
                          onChange={(e) => setUploadCsvData(e.target.files[0])}
                          style={{ width: "200px" }}
                        />

                        <MDButton
                          disabled={
                            !uploadCsvData?.name ||
                            uploadCsvData?.type !== "text/csv"
                          }
                          variant="contained"
                          color="info"
                          style={{ marginLeft: "1rem" }}
                          onClick={uploadCsvHandler}
                        >
                          UPLOAD
                        </MDButton>

                        <IconButton
                          size="small"
                          onClick={() => setShowUploadPanel(false)}
                          style={{ marginLeft: "10px", color: "gray" }}
                        >
                          <CloseIcon fontSize="small" />
                        </IconButton>
                      </MDBox>
                    )}
                  </MDBox>
                )}
              </MDBox>
            </MDBox>

            {/* DataTable */}
            <MDBox pt={0}>
              <DataTable
                table={{ columns, rows }}
                isSorted={true}
                tableSearch={true}
                entriesPerPage={{
                  defaultValue: 5,
                  entries: [5, 10, 15, 20, 25],
                }}
                showTotalEntries={true}
                noEndBorder
              />
            </MDBox>

            {/* VIEW MODAL (NEW) */}
            <Modal open={openViewModal} onClose={handleCloseViewModal}>
              <MDCard sx={styleForEdit}>
                <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                  <MDTypography variant="h4" fontWeight="medium" flexGrow={1}>
                    Care & Use Details
                  </MDTypography>
                  <Tooltip title="Close">
                    <IconButton
                      style={{
                        background: "whitesmoke",
                        color: "black",
                        borderRadius: 5,
                        marginRight: "10px",
                        marginTop: "4px",
                      }}
                      onClick={handleCloseViewModal}
                    >
                      <CloseIcon />
                    </IconButton>
                  </Tooltip>
                </MDBox>
                <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                <MDBox pt={1} pb={3} px={3}>
                  <Grid container spacing={2}>
                    {/* Basic Info */}
                    {renderViewField("DPP ID", singleDataForView.dppId)}
                    {renderViewField(
                      "Wash Temperature(°C)",
                      singleDataForView.washTemperature,
                    )}
                    {renderViewField(
                      "Ironing Instructions",
                      singleDataForView.ironingInstructions,
                    )}
                    {renderViewField(
                      "Dry Clean Status",
                      singleDataForView.dryCleanStatus,
                    )}
                    {renderViewField(
                      "Tumble Dry Instructions",
                      singleDataForView.tumbleDryInstructions,
                    )}
                    {renderViewField(
                      "Bleach Allowed",
                      getDisplayValue(singleDataForView.bleachAllowed, true),
                    )}

                    <Grid item xs={12}>
                      <MDTypography variant="h5" color="info" mt={2} mb={1}>
                        Instructions
                      </MDTypography>
                      <hr style={{ marginBottom: "1rem" }} />
                    </Grid>
                    {renderViewField(
                      "Handling Instructions",
                      singleDataForView.handlingInstructions,
                    )}
                    {renderViewField(
                      "Installation Instructions",
                      singleDataForView.installationInstructions,
                    )}
                    {renderViewField(
                      "Charging Instructions",
                      singleDataForView.chargingInstructions,
                    )}
                    {renderViewField(
                      "Storage Instructions",
                      singleDataForView.storageInstructions,
                    )}
                    {renderViewField(
                      "Transportation Instructions",
                      singleDataForView.transportationInstructions,
                    )}
                    {renderViewField(
                      "Disposal Instructions",
                      singleDataForView.disposalInstructions,
                    )}

                    <Grid item xs={12}>
                      <MDTypography variant="h5" color="info" mt={2} mb={1}>
                        Fire Risk
                      </MDTypography>
                      <hr style={{ marginBottom: "1rem" }} />
                    </Grid>
                    {renderViewField(
                      "Fire Hazard",
                      getDisplayValue(singleDataForView.fireHazard, true),
                    )}
                    {renderViewField(
                      "Thermal Runaway Risk",
                      getDisplayValue(
                        singleDataForView.thermalRunawayRisk,
                        true,
                      ),
                    )}
                    {renderViewField(
                      "Flammability",
                      getDisplayValue(
                        singleDataForView.flammability,
                        false,
                        true,
                      ),
                    )}
                    {renderViewField(
                      "Fire Risk Level",
                      singleDataForView.fireRiskLevel,
                    )}
                    {renderViewField(
                      "Fire Hazard Description",
                      singleDataForView.fireHazardDescription,
                    )}

                    <Grid item xs={12}>
                      <MDTypography variant="h5" color="info" mt={2} mb={1}>
                        Chemical Risk
                      </MDTypography>
                      <hr style={{ marginBottom: "1rem" }} />
                    </Grid>
                    {renderViewField(
                      "Chemical Hazard",
                      getDisplayValue(singleDataForView.chemicalHazard, true),
                    )}
                    {renderViewField(
                      "Chemical Risk Level",
                      singleDataForView.chemicalRiskLevel,
                    )}
                    {renderViewField(
                      "Chemical Hazard Description",
                      singleDataForView.chemicalHazardDescription,
                    )}

                    <Grid item xs={12}>
                      <MDTypography variant="h5" color="info" mt={2} mb={1}>
                        Electrical Risk
                      </MDTypography>
                      <hr style={{ marginBottom: "1rem" }} />
                    </Grid>
                    {renderViewField(
                      "Electrical Hazard",
                      getDisplayValue(singleDataForView.electricalHazard, true),
                    )}
                    {renderViewField(
                      "Voltage Hazard Level",
                      singleDataForView.voltageHazardLevel,
                    )}
                    {renderViewField(
                      "Electric Shock Risk",
                      getDisplayValue(
                        singleDataForView.electricShockRisk,
                        true,
                      ),
                    )}
                    {renderViewField(
                      "Electrical Risk Level",
                      singleDataForView.electricalRiskLevel,
                    )}

                    <Grid item xs={12}>
                      <MDTypography variant="h5" color="info" mt={2} mb={1}>
                        Transport Risk
                      </MDTypography>
                      <hr style={{ marginBottom: "1rem" }} />
                    </Grid>
                    {renderViewField(
                      "Transport Hazard",
                      getDisplayValue(singleDataForView.transportHazard, true),
                    )}
                    {renderViewField("UN Number", singleDataForView.uNNumber)}
                    {renderViewField(
                      "Transport Class",
                      singleDataForView.transportClass,
                    )}
                    {renderViewField(
                      "Proper Shipping Name",
                      singleDataForView.properShippingName,
                    )}
                    {renderViewField(
                      "Packing Instruction",
                      singleDataForView.packingInstruction,
                    )}
                  </Grid>
                </MDBox>
              </MDCard>
            </Modal>

            {/* CREATE MODAL */}
            <Modal open={openCreateModal} onClose={handleCloseCreateModal}>
              <MDCard sx={style}>
                <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                  <MDTypography variant="h5" fontWeight="medium" flexGrow={1}>
                    Create Care & Use Instructions
                  </MDTypography>
                  <Tooltip title="Close">
                    <IconButton
                      style={{
                        background: "whitesmoke",
                        color: "black",
                        borderRadius: 5,
                        marginRight: "10px",
                        marginTop: "4px",
                      }}
                      onClick={handleCloseCreateModal}
                    >
                      <CloseIcon />
                    </IconButton>
                  </Tooltip>
                </MDBox>
                <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />
                <MDBox pt={1} pb={3} px={3}>
                  <MDBox
                    component="form"
                    role="form"
                    onSubmit={formik.handleSubmit}
                  >
                    <Grid container spacing={2}>
                      {renderSelect("DPP", "DPPID", dppOptions, formik)}
                      {renderInput(
                        "Wash Temperature(°C)",
                        "washTemperature",
                        formik,
                      )}
                      {renderInput(
                        "Ironing Instructions",
                        "ironingInstructions",
                        formik,
                      )}
                      {renderInput(
                        "Dry Clean Status",
                        "dryCleanStatus",
                        formik,
                      )}
                      {renderInput(
                        "Tumble Dry Instructions",
                        "tumbleDryInstructions",
                        formik,
                      )}
                      {renderSelect(
                        "Bleach Allowed",
                        "bleachAllowed",
                        yesNoOptions,
                        formik,
                      )}
                      <Grid item xs={12}>
                        <MDTypography variant="h5" color="info" mt={2} mb={1}>
                          Instructions{" "}
                        </MDTypography>{" "}
                        <hr style={{ marginBottom: "1rem" }} />
                      </Grid>
                      {renderInput(
                        "Handling Instructions",
                        "handlingInstructions",
                        formik,
                      )}{" "}
                      {renderInput(
                        "Installation Instructions",
                        "installationInstructions",
                        formik,
                      )}{" "}
                      {renderInput(
                        "Charging Instructions",
                        "chargingInstructions",
                        formik,
                      )}{" "}
                      {renderInput(
                        "Storage Instructions",
                        "storageInstructions",
                        formik,
                      )}{" "}
                      {renderInput(
                        "Transportation Instructions",
                        "transportationInstructions",
                        formik,
                      )}{" "}
                      {renderInput(
                        "Disposal Instructions",
                        "disposalInstructions",
                        formik,
                      )}{" "}
                      {renderInput(
                        "Disassembly  Instructions",
                        "disassemblyInstruction",
                        formik,
                      )}
                      <Grid item xs={12}>
                        <MDTypography variant="h5" color="info" mt={2} mb={1}>
                          Fire Risk
                        </MDTypography>
                        <hr style={{ marginBottom: "1rem" }} />
                      </Grid>
                      {renderSelect(
                        "Fire Hazard",
                        "fireHazard",
                        yesNoOptions,
                        formik,
                      )}{" "}
                      {renderSelect(
                        "Thermal Runaway Risk",
                        "thermalRunawayRisk",
                        yesNoOptions,
                        formik,
                      )}{" "}
                      {renderSelect(
                        "Flammability",
                        "flammability",
                        flammabilityOptions,
                        formik,
                      )}{" "}
                      {renderSelect(
                        "Fire Risk Level",
                        "fireRiskLevel",
                        riskLevelOptions,
                        formik,
                      )}{" "}
                      {renderInput(
                        "Fire Hazard Description",
                        "fireHazardDescription",
                        formik,
                      )}
                      <Grid item xs={12}>
                        <MDTypography variant="h5" color="info" mt={2} mb={1}>
                          Chemical Risk
                        </MDTypography>
                        <hr style={{ marginBottom: "1rem" }} />
                      </Grid>
                      {renderSelect(
                        "Chemical Hazard",
                        "chemicalHazard",
                        yesNoOptions,
                        formik,
                      )}{" "}
                      {renderSelect(
                        "Chemical Risk Level",
                        "chemicalRiskLevel",
                        riskLevelOptions,
                        formik,
                      )}{" "}
                      {renderInput(
                        "Chemical Hazard Description",
                        "chemicalHazardDescription",
                        formik,
                      )}
                      <Grid item xs={12}>
                        <MDTypography variant="h5" color="info" mt={2} mb={1}>
                          Electrical Risk
                        </MDTypography>
                        <hr style={{ marginBottom: "1rem" }} />
                      </Grid>
                      {renderSelect(
                        "Electrical Hazard",
                        "electricalHazard",
                        yesNoOptions,
                        formik,
                      )}{" "}
                      {renderSelect(
                        "Voltage Hazard Level",
                        "voltageHazardLevel",
                        riskLevelOptions,
                        formik,
                      )}{" "}
                      {renderSelect(
                        "Electric Shock Risk",
                        "electricShockRisk",
                        yesNoOptions,
                        formik,
                      )}{" "}
                      {renderSelect(
                        "Electrical Risk Level",
                        "electricalRiskLevel",
                        riskLevelOptions,
                        formik,
                      )}
                      <Grid item xs={12}>
                        <MDTypography variant="h5" color="info" mt={2} mb={1}>
                          Transport Risk
                        </MDTypography>
                        <hr style={{ marginBottom: "1rem" }} />
                      </Grid>
                      {renderSelect(
                        "Transport Hazard",
                        "transportHazard",
                        yesNoOptions,
                        formik,
                      )}{" "}
                      {renderSelect(
                        "UN Number",
                        "uNNumber",
                        unNumberOptions,
                        formik,
                      )}{" "}
                      {renderSelect(
                        "Transport Class",
                        "transportClass",
                        transportClassOptions,
                        formik,
                      )}{" "}
                      {renderSelect(
                        "Proper Shipping Name",
                        "properShippingName",
                        shippingNameOptions,
                        formik,
                      )}{" "}
                      {renderSelect(
                        "Packing Instruction",
                        "packingInstruction",
                        packingInstructionOptions,
                        formik,
                      )}
                      <Grid item xs={12}>
                        <Collapse in={isErrorCreate}>
                          <Alert severity="error">{errorMsgCreate}</Alert>
                        </Collapse>
                        <Collapse in={isSuccessCreate}>
                          <Alert severity="success">Created Successfully</Alert>
                        </Collapse>
                        <MDBox mt={2}>
                          <MDButton
                            color="info"
                            type="submit"
                            fullWidth
                            disabled={createButtonName === "Please wait..."}
                          >
                            {createButtonName}
                          </MDButton>
                        </MDBox>
                      </Grid>
                    </Grid>
                  </MDBox>
                </MDBox>
              </MDCard>
            </Modal>

            {/* UPDATE MODAL */}
            <Modal open={openUpdateModal} onClose={handleCloseUpdateModal}>
              <MDCard sx={styleForEdit}>
                <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                  <MDTypography variant="h4" fontWeight="medium" flexGrow={1}>
                    Update Care & Use Instructions
                  </MDTypography>
                  <Tooltip title="Close">
                    <IconButton
                      style={{
                        background: "whitesmoke",
                        color: "black",
                        borderRadius: 5,
                        marginRight: "10px",
                        marginTop: "4px",
                      }}
                      onClick={handleCloseUpdateModal}
                    >
                      <CloseIcon />
                    </IconButton>
                  </Tooltip>
                </MDBox>
                <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />
                <MDBox pt={1} pb={3} px={3}>
                  <MDBox
                    component="form"
                    role="form"
                    onSubmit={formikForUpdate.handleSubmit}
                  >
                    <Grid container spacing={2}>
                      <Grid item xs={12} lg={4}>
                        <MDBox mb={1} ml={1}>
                          <MDTypography variant="h6">DPP ID</MDTypography>
                          <MDInput
                            size="small"
                            type="text"
                            name="DPPID"
                            fullWidth
                            disabled={true}
                            value={formikForUpdate.values.DPPID}
                          />
                        </MDBox>
                      </Grid>
                      {renderInput(
                        "Wash Temperature(°C)",
                        "washTemperature",
                        formikForUpdate,
                      )}{" "}
                      {renderInput(
                        "Ironing Instructions",
                        "ironingInstructions",
                        formikForUpdate,
                      )}{" "}
                      {renderInput(
                        "Dry Clean Status",
                        "dryCleanStatus",
                        formikForUpdate,
                      )}{" "}
                      {renderInput(
                        "Tumble Dry Instructions",
                        "tumbleDryInstructions",
                        formikForUpdate,
                      )}{" "}
                      {renderSelect(
                        "Bleach Allowed",
                        "bleachAllowed",
                        yesNoOptions,
                        formikForUpdate,
                      )}
                      <Grid item xs={12}>
                        <MDTypography variant="h5" color="info" mt={2} mb={1}>
                          Instructions
                        </MDTypography>
                        <hr style={{ marginBottom: "1rem" }} />
                      </Grid>
                      {renderInput(
                        "Handling Instructions",
                        "handlingInstructions",
                        formikForUpdate,
                      )}{" "}
                      {renderInput(
                        "Installation Instructions",
                        "installationInstructions",
                        formikForUpdate,
                      )}{" "}
                      {renderInput(
                        "Charging Instructions",
                        "chargingInstructions",
                        formikForUpdate,
                      )}{" "}
                      {renderInput(
                        "Storage Instructions",
                        "storageInstructions",
                        formikForUpdate,
                      )}{" "}
                      {renderInput(
                        "Transportation Instructions",
                        "transportationInstructions",
                        formikForUpdate,
                      )}{" "}
                      {renderInput(
                        "Disposal Instructions",
                        "disposalInstructions",
                        formikForUpdate,
                      )}
                      <Grid item xs={12}>
                        <MDTypography variant="h5" color="info" mt={2} mb={1}>
                          Fire Risk
                        </MDTypography>
                        <hr style={{ marginBottom: "1rem" }} />
                      </Grid>
                      {renderSelect(
                        "Fire Hazard",
                        "fireHazard",
                        yesNoOptions,
                        formikForUpdate,
                      )}{" "}
                      {renderSelect(
                        "Thermal Runaway Risk",
                        "thermalRunawayRisk",
                        yesNoOptions,
                        formikForUpdate,
                      )}{" "}
                      {renderSelect(
                        "Flammability",
                        "flammability",
                        flammabilityOptions,
                        formikForUpdate,
                      )}{" "}
                      {renderSelect(
                        "Fire Risk Level",
                        "fireRiskLevel",
                        riskLevelOptions,
                        formikForUpdate,
                      )}{" "}
                      {renderInput(
                        "Fire Hazard Description",
                        "fireHazardDescription",
                        formikForUpdate,
                      )}
                      <Grid item xs={12}>
                        <MDTypography variant="h5" color="info" mt={2} mb={1}>
                          Chemical Risk
                        </MDTypography>
                        <hr style={{ marginBottom: "1rem" }} />
                      </Grid>
                      {renderSelect(
                        "Chemical Hazard",
                        "chemicalHazard",
                        yesNoOptions,
                        formikForUpdate,
                      )}{" "}
                      {renderSelect(
                        "Chemical Risk Level",
                        "chemicalRiskLevel",
                        riskLevelOptions,
                        formikForUpdate,
                      )}{" "}
                      {renderInput(
                        "Chemical Hazard Description",
                        "chemicalHazardDescription",
                        formikForUpdate,
                      )}
                      <Grid item xs={12}>
                        <MDTypography variant="h5" color="info" mt={2} mb={1}>
                          Electrical Risk
                        </MDTypography>
                        <hr style={{ marginBottom: "1rem" }} />
                      </Grid>
                      {renderSelect(
                        "Electrical Hazard",
                        "electricalHazard",
                        yesNoOptions,
                        formikForUpdate,
                      )}{" "}
                      {renderSelect(
                        "Voltage Hazard Level",
                        "voltageHazardLevel",
                        riskLevelOptions,
                        formikForUpdate,
                      )}{" "}
                      {renderSelect(
                        "Electric Shock Risk",
                        "electricShockRisk",
                        yesNoOptions,
                        formikForUpdate,
                      )}{" "}
                      {renderSelect(
                        "Electrical Risk Level",
                        "electricalRiskLevel",
                        riskLevelOptions,
                        formikForUpdate,
                      )}
                      <Grid item xs={12}>
                        <MDTypography variant="h5" color="info" mt={2} mb={1}>
                          Transport Risk
                        </MDTypography>
                        <hr style={{ marginBottom: "1rem" }} />
                      </Grid>
                      {renderSelect(
                        "Transport Hazard",
                        "transportHazard",
                        yesNoOptions,
                        formikForUpdate,
                      )}{" "}
                      {renderSelect(
                        "UN Number",
                        "uNNumber",
                        unNumberOptions,
                        formikForUpdate,
                      )}{" "}
                      {renderSelect(
                        "Transport Class",
                        "transportClass",
                        transportClassOptions,
                        formikForUpdate,
                      )}{" "}
                      {renderSelect(
                        "Proper Shipping Name",
                        "properShippingName",
                        shippingNameOptions,
                        formikForUpdate,
                      )}{" "}
                      {renderSelect(
                        "Packing Instruction",
                        "packingInstruction",
                        packingInstructionOptions,
                        formikForUpdate,
                      )}
                      <Grid item xs={12}>
                        <Collapse in={isErrorForUpdate}>
                          <Alert severity="error">{errorMsgForUpdate}</Alert>
                        </Collapse>
                        <Collapse in={isSuccessForUpdate}>
                          <Alert severity="success">Updated successfully</Alert>
                        </Collapse>
                        <MDBox mt={2}>
                          <MDButton
                            color="info"
                            type="submit"
                            fullWidth
                            disabled={editButtonName === "Please wait..."}
                          >
                            {editButtonName}
                          </MDButton>
                        </MDBox>
                      </Grid>
                    </Grid>
                  </MDBox>
                </MDBox>
              </MDCard>
            </Modal>

            {/* DELETE MODAL */}
            <Modal open={openDeleteModal} onClose={handleCloseDeleteModal}>
              <MDCard sx={deleteStyle}>
                <MDTypography>Are you sure you want to delete?</MDTypography>
                <MDBox mt={2} display="flex" justifyContent="space-between">
                  <MDButton
                    color="info"
                    variant="outlined"
                    onClick={handleCloseDeleteModal}
                  >
                    Cancel
                  </MDButton>
                  <MDButton
                    color="error"
                    onClick={deleteRecord}
                    disabled={deleteButtonName === "Please wait..."}
                  >
                    {deleteButtonName}
                  </MDButton>
                </MDBox>
                <MDBox mt={2}>
                  <Collapse in={isErrorForDelete}>
                    <Alert severity="error">{errorMsgForDelete}</Alert>
                  </Collapse>
                  <Collapse in={isSuccessForDelete}>
                    <Alert severity="success">Deleted Successfully</Alert>
                  </Collapse>
                </MDBox>
              </MDCard>
            </Modal>
          </Grid>
        </Grid>
      </MDBox>

      {loading && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <ToastContainer />
    </div>
  );
};

const mapStateToProps = (state) => ({
  getAllCareAndUseReducer: state.getAllCareAndUseReducer,
  getProductsListForDppReducer: state.getProductsListForDppReducer,
  getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
});
const mapDispatchToProps = (dispatch) => ({
  getSubModulesByRoleId: (roleId, jwtToken) =>
    dispatch(getSubModulesByRoleId(roleId, jwtToken)),
  getAllCareAndUseInstructions: (jwtToken) =>
    dispatch(getAllCareAndUseInstructions(jwtToken)),
  createCareAndUseInstructions: (payload, jwtToken) =>
    dispatch(createCareAndUseInstructions(payload, jwtToken)),
  editCareAndUseInstructions: (payload, jwtToken) =>
    dispatch(editCareAndUseInstructions(payload, jwtToken)),
  deleteCareAndUseInstructions: (id, udBy, jwtToken) =>
    dispatch(deleteCareAndUseInstructions(id, udBy, jwtToken)),
  getProductsListForDpp: (jwtToken) =>
    dispatch(getProductsListForDpp(jwtToken)),
  uploadCsvForCareAndUseInstructions: (payload, jwtToken) =>
    dispatch(uploadCsvForCareAndUseInstructions(payload, jwtToken)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CareAndUseInstructions);
